const PENDING_PORTAL_LOGIN = 'portalLoginPending';

export const DEACTIVATED_ACCOUNT = 'Je account is gedeactiveerd. Neem contact op met Workfix als je weer toegang nodig hebt.';

export function markPortalLoginPending(storage = window.sessionStorage) {
    storage.setItem(PENDING_PORTAL_LOGIN, 'true');
}

export function takePendingPortalLogin(storage = window.sessionStorage) {
    const isPending = storage.getItem(PENDING_PORTAL_LOGIN) !== null;

    storage.removeItem(PENDING_PORTAL_LOGIN);

    return isPending;
}

export function reportPendingPortalLogin(store, ApiClient, storage = window.sessionStorage) {
    if (takePendingPortalLogin(storage)) {
        store.dispatch('users/recordPortalLogin', {ApiClient});
    }
}
